import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
(
    <Suspense fallback={<LoadingScreen />}>
        <Component {...props} />
    </Suspense>
);

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import('../pages/LoginPage')));
export const LoginSelection = Loadable(lazy(() => import('../pages/LoginSelectionPage')));
export const DealerLogin = Loadable(lazy(() => import('../pages/DealerLoginPage')));
export const PageOne = Loadable(lazy(() => import('../pages/PageOne')));
export const PageTwo = Loadable(lazy(() => import('../pages/PageTwo')));
export const PageThree = Loadable(lazy(() => import('../pages/PageThree')));
export const PageFour = Loadable(lazy(() => import('../pages/PageFour')));
export const PageFive = Loadable(lazy(() => import('../pages/PageFive')));
export const PageSix = Loadable(lazy(() => import('../pages/PageSix')));

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));

export const SetUserPage = Loadable(lazy(() => import('../pages/User/UserPage')));
export const SetUserLoginPage = Loadable(lazy(() => import('../pages/login')));
export const SetAllProjectAccessPage = Loadable(lazy(() => import('../pages/User/ProjectsAccessControlPage')));
export const EntLogin = Loadable(lazy(() => import('../pages/entlogin')));

// Added by Karishma 02-Dec-2024
export const ModuleRoleAccessListPage = Loadable(lazy(() => import('../pages/User/moduleroleaccesslistpage')));
export const ModuleRoleAccessListReport = Loadable(lazy(() => import('../pages/User/moduleroleaccesslistreport')));

export const ErrorPage = Loadable(lazy(() => import('../pages/ErrorPage')));